import React, {
    Fragment,
    useEffect,
    useState
} from "react";
import {
    Input,
    Button,
    FormFeedback,
    FormGroup,
    Label,
    InputGroup
} from "reactstrap";
import { connect } from "react-redux";
import Message from "../../CommonData/Data/Message.js";
import {
    clearDirectChangePasswordError,
    directChangePassword,
    directChangePasswordForm
} from "../../store/actions.js";

const DirectChangePassword = (props) => {

    const { handleClose, errorMessage, directPasswordForm, userId } = props;
    const { errors } = directPasswordForm || {};
    const [newPassword, setNewPassword] = useState(true);
    const [confirmPassword, setConfirmPassword] = useState(true);

    useEffect(() => {
        props.directChangePasswordForm({
            userId: userId,
            errors: {}
        });
        props.clearDirectChangePasswordError();
        //--------------------Key-Listener----------------------
        const handleKeyPress = (e) => {
            if (e.key === "Escape") {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [])

    const validateOnChange = (event) => {
        const { name, value } = event.target;
        console.log(value)
        props.directChangePasswordForm(
            {
                ...props.directPasswordForm,
                [name]: value,
                errors: {
                    ...props.directPasswordForm.errors,
                    [name]: null,
                }
            }
        );
    };

    const handleChangePassword = (e) => {
        e.preventDefault();
        const { directPasswordForm } = props;
        const { newPassword, confirmNewPassword } = directPasswordForm || {};

        let currentErrors = {};

        if (!newPassword) {
            currentErrors.newPassword = "New password is required";
        }
        if (!confirmNewPassword) {
            currentErrors.confirmNewPassword = "Confirm password is required";
        }
        props.directChangePasswordForm(
            {
                ...props.directPasswordForm,
                errors: currentErrors
            }
        );
        if (Object.keys(currentErrors).length === 0) {
            props.directChangePassword();
        }
    };

    return (
        <Fragment>
            {errorMessage && (
                <Message
                    type="danger"
                    defaultMessage={errorMessage}
                    baseClassName="alert"
                />
            )}
            <form className="mb-3" name="formChangePassword" onSubmit={handleChangePassword}>
                <FormGroup>
                    <Label >New Password<span className="text-danger">*</span></Label>
                    <InputGroup>
                        <Input
                            autoFocus
                            className={errors && errors.newPassword ? "border-end-0" : 'border-end-0 border-secondary'}
                            type={newPassword ? "password" : "text"}
                            name="newPassword"
                            placeholder="Enter new password"
                            onChange={validateOnChange}
                            invalid={errors && errors.newPassword}
                        />
                        <Button
                            className={errors && errors.newPassword ? "border-danger border-start-0 rounded-end" : 'border-secondary border-start-0 rounded-end'}
                            color='white'
                            onClick={() => setNewPassword(!newPassword)}
                        >
                            {newPassword ?
                                <i className="fas fa-eye text-secondary"></i>
                                :
                                <i class="fas fa-eye-slash text-secondary"></i>
                            }
                        </Button>
                        <FormFeedback>{errors && errors.newPassword}</FormFeedback>
                    </InputGroup>
                </FormGroup>
                <FormGroup>
                    <Label>Confirm Password<span className="text-danger">*</span></Label>
                    <InputGroup>
                        <Input
                            className={errors && errors.confirmNewPassword ? "border-end-0" : 'border-end-0 border-secondary'}
                            type={confirmPassword ? "password" : "text"}
                            name="confirmNewPassword"
                            placeholder="Enter confirm password"
                            onChange={validateOnChange}
                            invalid={errors && errors.confirmNewPassword}
                        />
                        <Button
                            className={errors && errors.confirmNewPassword ? "border-danger border-start-0 rounded-end" : 'border-secondary border-start-0 rounded-end'}
                            color='white'
                            onClick={() => setConfirmPassword(!confirmPassword)}
                        >
                            {confirmPassword ?
                                <i className="fas fa-eye text-secondary"></i>
                                :
                                <i class="fas fa-eye-slash text-secondary"></i>
                            }
                        </Button>
                        <FormFeedback>{errors && errors.confirmNewPassword}</FormFeedback>
                    </InputGroup>
                </FormGroup>
                <FormGroup>
                    <Button
                        type="submit"
                        className='me-4'
                        color="primary"
                        onClick={handleChangePassword}
                    >Submit
                    </Button>
                    <Button
                        color="danger"
                        onClick={handleClose}
                    >Cancel
                    </Button>
                </FormGroup>
            </form>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    directPasswordForm: state.userdetails.directPasswordForm,
    isPending: state.userdetails.isDirectChangePasswordPending,
    errorMessage: state.userdetails.isDirectChangeErrorMessage,
});

const mapDispatchToProps = (dispatch) => ({
    directChangePasswordForm: (passwordForm) => dispatch(directChangePasswordForm(passwordForm)),
    directChangePassword: () => dispatch(directChangePassword()),
    clearDirectChangePasswordError: () => dispatch(clearDirectChangePasswordError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DirectChangePassword);
